const NON_TENANT_SUBDOMAINS = ['www', 'app', 'devapp', 'testapp', 'preprodapp'];

export function getTenantSlug() {
  if (typeof window === 'undefined') return null;

  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  // Real subdomain (production / staging) e.g. kss.keyskillset.com → 'kss'
  if (parts.length >= 2) {
    const subdomain = parts[0];
    if (!NON_TENANT_SUBDOMAINS.includes(subdomain)) {
      return subdomain;
    }
  }


  try {
    return localStorage.getItem('tenant_kss') || null;
  } catch (_) {
    return null;
  }
}

export function isTenantContext() {
  return getTenantSlug() !== null;
}
